module.exports = __webpack_public_path__ + "fcca12a3612908c63d0029c0ca3620ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/brand/logo.png
// module id = 546
// module chunks = 4